import React from 'react';
import { GenericEntry } from '../..';
import { User } from '../../../../../entities/User';
import { Application } from '../../../../../entities/Application';
import { Simple } from '../../../../../entities/ApplicationFeed';
import { AlertObject } from '../../../../../components/Alert';

interface PropTypes {
  application: Application;
  entry: Simple;
  currentUser: User;
  isLastItemInPage: boolean;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function BackgroundCheckCancelledEntry(props: PropTypes) {
  return (
    <GenericEntry
      icon='bi-file-earmark-x'
      iconClassName='bg-pink-light'
      title={<>The background check process has been cancelled.</>}
      date={props.entry.createdAt}
      {...props}
    />
  );
}
